// https://github.com/elsevierPTG/eols-config-property-store/blob/master/sherpath-course-management-service.yaml
export enum Application {
  EAQ = 'EAQ',
  EPM_SKILL = 'EPM_SKILL',
  KNOWLEDGECARD = 'KNOWLEDGECARD',
  PERFORMANCE = 'PERFORMANCE',
  SHER_EVOL = 'SHER_EVOL',
  SHERPATH = 'SHERPATH',
  SIMSNG = 'SIMSNG',
  HESI_NG = 'HESI_NG',
  HESI_LS= 'HESI_LS',
  SHADOW_HEALTH = 'SHADOW_HEALTH',
  NCO = 'NCO',
  AUTHESS = 'AUTHESS',
  EAB = 'EAB',
  ASSIGNMENT_MANAGEMENT = 'ASSIGNMENT_MANAGEMENT',
  STUDENT_STUDY = 'STUDENT_STUDY',
  NHE_ASSESSMENT_PLAYER = 'NHE_ASSESSMENT_PLAYER',
  NHE_AI = 'NHE_AI',
  SCMO = 'SCMO',
  REMEDIATION = 'REMEDIATION',
  EHE_MEDICAL_ASSESSMENT = 'EHE_MEDICAL_ASSESSMENT',
}

export enum AppAction {
  ASSESSMENT_GRADE_EDIT = 'ASSESSMENT_GRADE_EDIT',
  ASSESSMENT_PERFORMANCE_VIEW = 'ASSESSMENT_PERFORMANCE_VIEW',
  ASSESSMENT_START = 'ASSESSMENT_START',
  ASSIGNMENT_CREATE = 'ASSIGNMENT_CREATE',
  ASSIGNMENT_EDIT = 'ASSIGNMENT_EDIT',
  ASSIGNMENT_PERFORMANCE_VIEW = 'ASSIGNMENT_PERFORMANCE_VIEW',
  ASSIGNMENT_PREVIEW = 'ASSIGNMENT_PREVIEW',
  PERFORMANCE_VIEW = 'PERFORMANCE_VIEW',
  LAUNCH = 'LAUNCH',
}

export enum AppLinkTargetCapability {
  TEST_PLAYER = 'test-player',
  ASSESSMENT_RESULT_VIEW = 'assessment-result-view',
  STUDENT_ASSESSMENT_CREATION = 'student-assessment-creation',
  ASSIGNMENT_BUILDER = 'assignment-builder',
  USMLE_MOCK_EXAM = 'usmle-mock-exam',
  STUDENT_PERFORMANCE = 'student-performance',
  KNOWLEDGE_CHECK = 'knowledge-check',
  FACULTY_PERFORMANCE = 'faculty-performance',
}

export enum NavigationType {
  NOT_SURE_CONFIDENT = 'NotSure-Confident',
  TWO_WAY = 'Next-Back',
  SUBMIT_AND_CONTINUE = 'Submit-Continue',
  NEXT = 'Next',
}

export enum QuestionSkippingType {
  ANSWERED_AND_SKIPPED_QUESTIONS = 'answeredAndSkippedQuestions',
  PREVIEW_NAVIGATION = 'previewNavigation',
  NONE = 'none',
}

export enum ScmoNgSubType {
  SIMULATION_PLAYGROUND_INSTRUCTOR = 'SIMULATION_PLAYGROUND_INSTRUCTOR',
  SIMULATION_PLAYGROUND_STUDENT = 'SIMULATION_PLAYGROUND_STUDENT',
}
